import { useContext, createContext } from "react";

export const AppContext = createContext(null);
export const AlertContext = createContext(null);

export function useAppContext() {
  return useContext(AppContext);
}

export function useAlertContext() {
  return useContext(AlertContext);
}

